import {getActStates} from "../../redux/actions/actStateActions";
import {getDepartments, getDivisions, getFilials} from "../../redux/actions";
import { filialDivisionCRUD } from "../../http";

const normalizeFilialDivisionRowForFilter = (row) => ({
  ...row,
  id: row.id ?? row.Id,
  name: row.name ?? row.Name,
  filialId: row.filialId ?? row.FilialId,
});

export const actsSearchFields = [
    {
        title: "ID",
        key: "id",
        compareType: "equals",
        operandPosition:1,
        filterType:"normal"
    },
    {
        title: "Номер",
        key: "number",
        compareType: "like",
        operandPosition:1,
        filterType:"normal"
    }
];

export const actsFilterFields = [
    {
        title: "Дата создания от",
        key: "createdAt",
        operandPosition: 1,
        compareType: "between",
        type: "date2",
        filterType: "normal",
    },
    {
        title: "Дата создания до",
        key: "createdAt",
        operandPosition: 2,
        compareType: "between",
        type: "date2",
        filterType: "normal",
    },
    {
        title: "Cтатус",
        key: "stateId",
        compareType: "equals",
        reducerKey: "actState",
        reducerArrayKey: "actStates",
        reducerAction: getActStates,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Филиал",
        key: "filialId",
        compareType: "equals",
        reducerKey: "filial",
        reducerArrayKey: "filials",
        reducerAction: getFilials,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Районное отделение",
        key: "filialDivisionId",
        compareType: "equals",
        reducerKey: "filialDivision",
        operandPosition: 1,
        parentKey: 'filialId',
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
        useDomainSelect2: true,
        domainSelectCrud: filialDivisionCRUD,
        selectMembers: ["Id", "Name", "FilialId"],
        normalizeOption: normalizeFilialDivisionRowForFilter,
        domainSelect2SkipFetchWithoutParent: true,
        domainSelect2NoParentHint: "Выберите филиал",
    },
    {
        title: "Лаборатория",
        key: "departmentId",
        compareType: "equals",
        reducerKey: "department",
        reducerArrayKey: "departments",
        reducerAction: getDepartments,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
    {
        title: "Отдел",
        key: "divisionId",
        compareType: "equals",
        reducerKey: "division",
        reducerArrayKey: "divisions",
        reducerAction: getDivisions,
        operandPosition: 1,
        optionLabelKey: "name",
        type: "normal",
        filterType: "normal",
    },
]